import React, { lazy, Suspense } from "react";
export { default as Print_ViewLoan } from "./Print_ViewLoan";

const LazyListCustomerOwes = lazy(() => import("./ListCustomerOwes"));
const LazyListLoanRecipe = lazy(() => import("./ListLoanRecipe"));
export const ListCustomerOwes = () => (
  <Suspense fallback="loading...">
    <LazyListCustomerOwes />
  </Suspense>
);
export const ListLoanRecipe = () => (
  <Suspense fallback="loading...">
    <LazyListLoanRecipe />
  </Suspense>
);